import { render } from "./LoadMedicina.vue?vue&type=template&id=b2fac884&scoped=true"
import script from "./LoadMedicina.vue?vue&type=script&lang=js"
export * from "./LoadMedicina.vue?vue&type=script&lang=js"

import "./LoadMedicina.vue?vue&type=style&index=0&id=b2fac884&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fac884"]])

export default __exports__